import { createContextFactory } from "@devowl-wp/utils";
import { AccountV1Store } from "./accountV1.js";
import { CheckoutV1Store } from "./checkoutV1.js";
import { NotificationStore } from "./notification.js";
import { OptionStore } from "./option.js";
import { AccountV2Store } from "../shortcode/accountV2/store/accountV2Store.js";
import { CheckoutV2Store } from "../shortcode/checkoutV2/store/CheckoutV2Store.js";
/**
 * A collection of all available stores which gets available
 * through the custom hook useStores in your function components.
 *
 * @see https://mobx.js.org/best/store.html#combining-multiple-stores
 */ class RootStore {
    get context() {
        return this.contextMemo ? this.contextMemo : this.contextMemo = createContextFactory(this);
    }
    constructor(){
        this.optionStore = new OptionStore(this);
        this.notificationStore = new NotificationStore(this);
        this.checkoutV1Store = new CheckoutV1Store(this);
        this.checkoutV2Store = new CheckoutV2Store(this);
        this.accountV1Store = new AccountV1Store(this);
        this.accountV2Store = new AccountV2Store(this);
    }
    static get StoreProvider() {
        return RootStore.get.context.StoreProvider;
    }
    static get get() {
        return RootStore.me ? RootStore.me : RootStore.me = new RootStore();
    }
}
const useStores = ()=>RootStore.get.context.useStores();
export { RootStore, useStores };
